import type { OwnAiCredentials } from '@orbit-mind/shared-types';
import { storageAccount } from '../engine/storage';
const sessions = new Map<string, OwnAiCredentials>();
export function readOwnAi(): OwnAiCredentials | null {
  const id = storageAccount();
  return id === null ? null : (sessions.get(id) ?? null);
}
export function saveOwnAi(value: OwnAiCredentials | null): void {
  const id = storageAccount();
  if (id === null) throw new Error('Entre na sua conta para configurar uma chave própria.');
  if (value === null) sessions.delete(id);
  else sessions.set(id, value);
}

export function clearOwnAi(): void {
  sessions.clear();
}
